module.exports = __webpack_public_path__ + "static/media/washhand.c310ee46.svg";